// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3mUNw","list":"styles__list___1wLH4"};